import configuration from '@/taskpane/common/configuration'
import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import LinkInfo from '../models/link-info'
import TrackingInfo from '@/taskpane/services/models/tracking-info'
import TrackingInfoRecipient from '@/taskpane/services/models/tracking-info-recipients'

export interface SaveEmailTrackingInfoArgs {
  emailGuid: string
  links: LinkInfo[]
  replyTrackingId: string
}

export default async function saveEmailTrackingInfoHandler(data: SaveEmailTrackingInfoArgs) {
  try {
    const trackingInfo = await getTrackingInfo(data)

    if (trackingInfo.subject && trackingInfo.recipients.length > 0) {
      state.currentItem.trackingInfoSentWithoutThreadId = !trackingInfo.conversationId
      await office.customProps.setTrackingId(data.emailGuid)
      await office.customProps.setReplyTrackingId(data.replyTrackingId)
    }
  } catch {
    // no callback
  }
}

async function getTrackingInfo(data: SaveEmailTrackingInfoArgs): Promise<TrackingInfo> {
  const [id, to, cc, bcc, subject] = await Promise.all([office.id(), office.mail.to(), office.mail.cc(), office.mail.bcc(), office.subject.get()])

  return {
    clientType: configuration.CLIENT_TYPE,
    conversationId: office.mail.conversationId(),
    conversationIndex: id,
    emailGuid: data.emailGuid,
    event: '',
    firstName: firstName(office.profile.displayName()),
    from: office.profile.username().toLowerCase(),
    lastname: lastName(office.profile.displayName()),
    links: data.links.filter((link) => link.linkGuid),
    recipients: formatRecipients(to, 'to').concat(formatRecipients(cc, 'cc'), formatRecipients(bcc, 'bcc')),
    sentTimestamp: new Date().toISOString(),
    subject: subject,
    topic: subject,
  }
}

function formatRecipients(recipients: Office.EmailAddressDetails[], type: string): TrackingInfoRecipient[] {
  return recipients.map((recipient) => {
    return {
      emailAddress: recipient.emailAddress.toLowerCase(),
      firstName: firstName(recipient.displayName),
      lastName: lastName(recipient.displayName),
      type: type,
    }
  })
}

function firstName(name: string): string {
  return splitName(name)[0]
}

function lastName(name: string): string {
  return splitName(name)[1]
}

function splitName(name: string): string[] {
  if (!name) {
    return ['', '']
  }

  const parts = name.split(' ')

  if (parts.length === 1) {
    return ['', parts[0]]
  }

  if (parts.length === 2) {
    return parts
  }

  const firstName = parts.shift()

  return [firstName, parts.join(' ')]
}
